<template>
  <basic-dialog :show="show" @close="$emit('close')" maxWidth="600px">
    <template v-slot:title>{{ editorTitle }}</template>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>

    <v-row>
      <v-col>
        <v-text-field
          label="Name"
          v-model="name"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea label="Notes" v-model="notes" :outlined="outlinedInputs" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <date-picker
          customLabel="Due Date"
          @onDateSelected="onDueDateSelected"
          :gtDateString="dueDate"
          :outlined="outlinedInputs"
        ></date-picker>
      </v-col>
      <v-col>
        <v-switch label="Complete" v-model="isComplete" hide-details></v-switch>
      </v-col>
    </v-row>
    <v-row v-if="debug">
      <v-col cols="12">
        value:
        <code>{{ value }}</code>
      </v-col>
    </v-row>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog";

import DatePicker from "../../shared/DatePicker.vue";
const randomize = require("randomatic");
export default {
  name: "edit-action-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => {},
    },
  },

  components: { BasicDialog, DatePicker },

  data() {
    return {
      debug: false,
      id: this.value ? this.value.id : undefined,
      name: this.value ? this.value.name : "",
      notes: this.value ? this.value.notes : "",
      dueDate: this.value ? this.value.dueDate : "",
      isComplete: this.value ? this.value.isComplete : false,
      _uid: this.value ? this.value._uid : undefined,
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return this.name != "";
    },
    editorTitle() {
      return this.name != "" ? this.name : "Edit Action";
    },
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.id = newVal.id;
        this.name = newVal.name;
        this.isComplete = newVal.isComplete;
        this._uid = newVal._uid;
        this.notes = newVal.notes;
        this.dueDate = newVal.dueDate;
      }
    },
  },

  methods: {
    onDueDateSelected(payload) {
      this.dueDate = payload;
    },
    onSave() {
      this.$emit("input", {
        name: this.name,
        id: this.id,
        isComplete: this.isComplete,
        notes: this.notes,
        dueDate: this.dueDate,
        _uid: this._uid ? this._uid : randomize("Aa0", 32),
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/plugins/task-tracker/EditActionDialog.vue